import { useState, useEffect } from 'react';

export default function HeroSection() {
  const stats = [
    { value: '50+', label: '优质平台收录' },
    { value: '每日更新', label: '内容持续跟进' },
    { value: '免费畅看', label: '高清流畅播放' },
  ];

  const [imgError, setImgError] = useState(false);

  return (
    <section id="hero" className="relative min-h-[580px] md:min-h-[680px] flex items-center bg-background-50 overflow-hidden pt-[64px] md:pt-[72px]">
      <div className="absolute inset-0 overflow-hidden opacity-[0.04] pointer-events-none">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-primary-500 blur-3xl"></div>
        <div className="absolute top-1/2 -left-32 w-80 h-80 rounded-full bg-accent-500 blur-3xl"></div>
        <div className="absolute -bottom-20 right-1/3 w-64 h-64 rounded-full bg-secondary-500 blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-14">
            <div className="flex-1 w-full text-center lg:text-left">
              <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-4 whitespace-nowrap">
                视频平台推荐大全
              </span>

              <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight">
                69视频
                <span className="block text-2xl md:text-3xl lg:text-4xl text-foreground-700 mt-1">
                  发现你的下一个视频世界
                </span>
              </h1>

              <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg mx-auto lg:mx-0">
                69视频致力于为影迷观众整理全网优质视频平台资源。从香蕉视频到红桃视频，从91视频到蜜桃视频，我们聚合海量免费在线观看入口，涵盖最新高清电影、热播电视剧和热门综艺节目，无需缓冲，流畅播放，一站式满足你的观影需求。无论你偏好哪种类型，都能在这里找到心仪的平台。
              </p>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-6">
                {stats.map((stat) => (
                  <div key={stat.label} className="text-center">
                    <span className="block text-xl md:text-2xl font-heading font-bold text-primary-500">{stat.value}</span>
                    <span className="block text-xs text-foreground-500 mt-0.5">{stat.label}</span>
                  </div>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-7">
                <a
                  href="#updates"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap no-underline"
                >
                  浏览最新快讯
                  <i className="ri-arrow-right-line"></i>
                </a>
                <a
                  href="#index"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-100 text-foreground-700 text-sm font-medium hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap no-underline border border-background-300"
                >
                  探索主题索引
                  <i className="ri-compass-3-line"></i>
                </a>
              </div>
            </div>

            <div className="flex-1 w-full max-w-md lg:max-w-none">
              <div className="relative rounded-2xl overflow-hidden bg-background-100 aspect-[4/3]">
                {!imgError ? (
                  <img
                    src="https://readdy.ai/api/search-image?query=Abstract%20digital%20entertainment%20composition%20with%20overlapping%20translucent%20geometric%20shapes%20in%20warm%20coral%20and%20amber%20tones%2C%20modern%20clean%20aesthetic%2C%20soft%20gradient%20layers%20representing%20video%20streaming%20platforms%2C%20cinematic%20atmosphere%2C%20high%20detail%2C%20editorial%20quality%2C%20harmonious%20warm%20color%20palette&width=800&height=600&seq=69video-hero-visual&orientation=landscape"
                    alt="69视频平台推荐 - 发现优质视频平台"
                    title="69视频-视频平台推荐"
                    className="w-full h-full object-cover"
                    onError={() => setImgError(true)}
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-foreground-400">
                    <i className="ri-movie-2-line text-5xl"></i>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}